import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Verify = () => {
    let {id, code} = useParams();
    
    const [verified, setVerified] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_USER_API_URL}/users/verify/${id}/${code}`, {method: "POST"}).then((response) => {
                return response.json();
            }).then((data) => {
                setVerified(data.verified);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <main className="status-shell">
            <section className="status-card">
                <div className="status-icon animate-pulse">...</div>
                <h1 className="page-heading !text-3xl">Verifying your account</h1>
                <p className="page-subtitle">This should only take a moment.</p>
            </section>
        </main>
    }

    return(
        <main className="status-shell">
            <section className="status-card">
                <div className={`status-icon ${verified ? "!bg-emerald-600" : "!bg-red-600"}`}>
                    {verified ? "✓" : "!"}
                </div>
                <h1 className="page-heading !text-3xl">
                    {verified ? "Verification complete" : "Verification failed"}
                </h1>
                <p className="page-subtitle">
                    {verified ? "Your account is ready. You can return to Pygmalion and log in." : "This verification link is invalid or has expired."}
                </p>
                <a className="mt-6 inline-flex min-h-[2.75rem] items-center justify-center rounded-xl bg-[#176b87] px-5 py-2.5 text-sm font-bold text-white" href="/">
                    Return to login
                </a>
            </section>
        </main>
    );
};

export default Verify;
